import gql from 'graphql-tag'

export const USER_PARTS = gql`
  fragment UserParts on User {
    id: _id
    name
    nickname
    avatar_url
    main_department_id {
      id: _id
      name
      complete_name
    }
  }
`

export const STATEMENT_PARTS = gql`
  fragment StatementParts on Statement {
    id: _id
    content: published_content
    related_objective_id {
      id: _id
      content: published_content
      key_results {
        id: _id
        content
        progress
        start_day
        finish_day
        indicator
        collaborators
      }
    }
    related_keyresult_id {
      id: _id
      content: published_content
    }
    create_uid {
      ...UserParts
    }
  }
`

export const COMMENT_PARTS = gql`
  fragment CommentParts on Message {
    id: _id
    body
    date
    create_uid {
      _id
      name
    }
    parent_id {
      id: _id
    }
    reply_to_id {
      id: _id
      create_uid {
        id: _id
        name
      }
    },
    attachment_ids {
      id: _id
      name
    }
  }
`

export const HR_DEPARTMENT_PARTS = gql`
  fragment HrDepartmentParts on HrDepartment {
    id: _id
    complete_name
    name
    user_ids @include(if: $withEmployees) {
      id: _id
      name
      nickname
      avatar_url
      main_department_id {
        id: _id
        name
        complete_name
      }
    }
    child_ids @include(if: $widthChild) {
      id: _id
      complete_name
      name
    }
  }
`
